import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function Send(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" {...props}>
      <path d="M2.01 21.5L23 12.5L2.01 3.5L2 10.5L17 12.5L2 14.5L2.01 21.5Z" />
    </SvgIcon>
  );
}

export default Send;
